import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LocalTips.css";

const LocalTips = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="mag-full-center-section">
      <div className="mag-full-center-bg">
        <span className="mag-center-bg-char">{t("localTips.bgText")}</span>
      </div>

      <div className="mag-full-center-content animate-fade-up">
        <span className="mag-label">{t("localTips.label")}</span>
        <h2 className="mag-home-title">{t("localTips.title")}</h2>
        <p className="mag-home-subtitle">
          {t("localTips.description")}
        </p>
        
        <button 
          className="mag-home-button centered"
          onClick={() => navigate("/buyHome")}
        >
          <span>{t("localTips.button")}</span>
          <div className="mag-button-line"></div>
        </button>
      </div>
    </section>
  );
};

export default LocalTips;